import { render, staticRenderFns } from "./register-progress.vue?vue&type=template&id=24148e36&scoped=true&"
import script from "./register-progress.vue?vue&type=script&lang=ts&"
export * from "./register-progress.vue?vue&type=script&lang=ts&"
import style0 from "./register-progress.vue?vue&type=style&index=0&id=24148e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24148e36",
  null
  
)

export default component.exports